import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'

export const headerLogoStyle = {
    textDecoration: 'none',
    display: 'block',
    // Desktop only: prevent logo from shrinking so it stays fixed size
    flexShrink: {base: undefined, sm: undefined, md: 0, lg: 0},
    img: {
        width: {base: pxToRem(86), sm: pxToRem(86), md: pxToRem(145.59), lg: pxToRem(145.59)},
        height: {base: pxToRem(20), sm: pxToRem(20), md: pxToRem(34), lg: pxToRem(34)},
        minWidth: {base: undefined, sm: undefined, md: pxToRem(145.59), lg: pxToRem(145.59)},
        minHeight: {base: undefined, sm: undefined, md: pxToRem(34), lg: pxToRem(34)},
        aspectRatio: {base: '43/10', sm: '43/10', md: '167/39', lg: '167/39'},
        objectFit: 'contain'
    }
}

export const cartHeadingStyle = {
    fontFamily: fonts.primary,
    fontWeight: 700,
    fontSize: pxToRem(15),
    color: 'black',
    padding: pxToRem(15),
    paddingLeft: pxToRem(7.5),
    h5: {
        fontWeight: 700
    }
}

export const priceContentStyle = {
    p: {
        fontFamily: fonts.secondary,
        fontSize: pxToRem(13),
        color: 'black'
    },

    '.property-container': {
        display: 'flex',
        flexWrap: 'wrap'
    },

    '.property-item': {
        whiteSpace: 'wrap'
    },

    '.fullWidth': {
        width: '100%'
    },

    '.pipe': {
        padding: '0 7px'
    },

    '.qty-new-line': {
        width: '100%',
        display: 'block',
        marginTop: pxToRem(2)
    }
}

export const priceDiscountContentStyle = {
    fontFamily: fonts.secondary,
    fontSize: pxToRem(13),
    fontWeight: 700,
    textDecoration: 'line-through',
    marginBottom: pxToRem(5)
}

export const cartBodyStyle = {
    maxHeight: pxToRem(300),
    overflowY: 'auto',

    a: {
        display: 'inline-block',
        color: 'black',
        textDecoration: 'none',
        fontFamily: fonts.secondary,
        fontSize: pxToRem(13),
        _hover: {
            outline: 0,
            textDecoration: 'none'
        }
    },
    p: {
        fontSize: pxToRem(13),
        fontFamily: fonts.secondary,
        letterSpacing: pxToRem(1)
    }
}

export const cartBadgeStyle = {
    color: 'white',
    right: [pxToRem(-8), pxToRem(-8), pxToRem(-5), pxToRem(-5)],
    top: [pxToRem(-10), pxToRem(-10), '1rem', '1rem']
}

export const cartFooterStyles = {
    backgroundColor: 'cav_deep_light_gray',

    '.mini-cart-subtotals': {
        fontWeight: 700,
        paddingTop: pxToRem(16),
        paddingBottom: pxToRem(20),
        color: 'cav_black'
    },
    p: {
        margin: 0,
        fontSize: pxToRem(14),
        textTransform: 'uppercase',
        letterSpacing: pxToRem(3),
        fontFamily: fonts.secondary,
        marginBottom: pxToRem(5),
        marginLeft: pxToRem(15)
    },
    '.btn-container': {
        display: 'flex',
        justfyContent: 'center',
        fontFamily: fonts.secondary
    },
    'a.button': {
        textTransform: 'uppercase',
        letterSpacing: pxToRem(3.64),
        backgroundColor: 'cav_clay',
        width: '90%',
        textAlign: 'center',
        padding: `0 ${pxToRem(42)}`,
        lineHeight: pxToRem(44),
        minWidth: pxToRem(180),
        color: 'white',
        fontFamily: fonts.primary,
        ':hover': {
            backgroundColor: 'cav_btn_light_black',
            textDecoration: 'none',
            outline: 0
        }
    }
}

export const menuIconStyle = {
    width: {base: pxToRem(30), sm: pxToRem(30), md: pxToRem(28), lg: pxToRem(28)},
    height: {base: pxToRem(30), sm: pxToRem(30), md: pxToRem(28), lg: pxToRem(28)},
    '.menu-icon': {
        display: 'block',
        backgroundColor: 'white',
        position: 'absolute',
        top: '50%',
        left: 0,
        transform: 'translateY(-50%)',
        height: {base: pxToRem(2), sm: pxToRem(2), md: pxToRem(3), lg: pxToRem(3)},
        width: {base: pxToRem(22), sm: pxToRem(22), md: pxToRem(28), lg: pxToRem(28)},
        transition: 'transform 400ms cubic-bezier(0.23, 1, 0.32, 1)',
        borderRadius: pxToRem(2),
        fontSize: '2.0em'
    },
    '.menu-icon::before ': {
        content: `''`,
        marginTop: {base: pxToRem(-6.5), sm: pxToRem(-6.5), md: pxToRem(-8), lg: pxToRem(-8)},
        top: '0',
        display: 'block',
        backgroundColor: 'white',
        position: 'absolute',
        height: {base: pxToRem(2), sm: pxToRem(2), md: pxToRem(3), lg: pxToRem(3)},
        width: {base: pxToRem(22), sm: pxToRem(22), md: pxToRem(28), lg: pxToRem(28)},
        transition: 'transform 1000ms cubic-bezier(0.23, 1, 0.32, 1)',
        borderRadius: pxToRem(2)
    },
    '.menu-icon::after ': {
        content: `''`,
        marginTop: {base: pxToRem(6.5), sm: pxToRem(6.5), md: pxToRem(8), lg: pxToRem(8)},
        top: '0',
        display: 'block',
        backgroundColor: 'white',
        position: 'absolute',
        height: {base: pxToRem(2), sm: pxToRem(2), md: pxToRem(3), lg: pxToRem(3)},
        width: {base: pxToRem(22), sm: pxToRem(22), md: pxToRem(28), lg: pxToRem(28)},
        transition: 'transform 1000ms cubic-bezier(0.23, 1, 0.32, 1)',
        borderRadius: pxToRem(2)
    }
}

export const toggleMenuIconStyle = {
    width: {base: pxToRem(30), sm: pxToRem(30), md: pxToRem(28), lg: pxToRem(28)},
    height: {base: pxToRem(30), sm: pxToRem(30), md: pxToRem(28), lg: pxToRem(28)},
    '.menu-icon': {
        display: 'block',
        backgroundColor: 'white',
        position: 'absolute',
        top: '50%',
        left: 0,
        transform: 'translateY(-50%)',
        height: '0',
        width: {base: pxToRem(22), sm: pxToRem(22), md: pxToRem(28), lg: pxToRem(28)},
        transition: 'transform 400ms cubic-bezier(0.23, 1, 0.32, 1)',
        borderRadius: pxToRem(2),
        fontSize: '2.0em'
    },
    '.menu-icon::before ': {
        content: `''`,
        top: '0',
        display: 'block',
        backgroundColor: 'white',
        position: 'absolute',
        height: {base: pxToRem(2), sm: pxToRem(2), md: pxToRem(3), lg: pxToRem(3)},
        width: {base: pxToRem(22), sm: pxToRem(22), md: pxToRem(28), lg: pxToRem(28)},
        transition: 'transform 1000ms cubic-bezier(0.23, 1, 0.32, 1)',
        borderRadius: pxToRem(2),
        marginTop: '0',
        transform: 'rotate(405deg)'
    },
    '.menu-icon::after ': {
        content: `''`,
        top: '0',
        display: 'block',
        backgroundColor: 'white',
        position: 'absolute',
        height: {base: pxToRem(2), sm: pxToRem(2), md: pxToRem(3), lg: pxToRem(3)},
        width: {base: pxToRem(22), sm: pxToRem(22), md: pxToRem(28), lg: pxToRem(28)},
        transition: 'transform 1000ms cubic-bezier(0.23, 1, 0.32, 1)',
        borderRadius: pxToRem(2),
        marginTop: '0',
        transform: 'rotate(-405deg)'
    }
}

export const giftName = {
    fontFamily: fonts.secondary
}
